import { safraRepository } from '@/services/database/repositories/SafraRepository';
import { municipioUfRepository } from '@/services/database/repositories/MunicipioUfRepository';

export default {
  methods: {
    async buscarMunicipioUf() {
      try {
        // 1. Verifica se precisa atualizar do backend
        const needsRefresh = await municipioUfRepository.needsRefresh();

        if (needsRefresh) {
          const response = await this.$http.get("/api/astec/municipioUfLkp");
          await municipioUfRepository.bulkUpsert(response.data);
        }

        // 2. Busca sempre do banco local
        const municipios = await municipioUfRepository.findAll();

        // 3. Mapeia para o formato que seu componente espera
        this.selecaoMunicipioLkp = municipios.map(municipio => ({
          name: municipio.regiao,  // "6 - PORTO VELHO SAILE - RO" (com código)
          value: municipio.value    // "6" (apenas o código)
        }));

      } catch (err) {
        // Fallback para dados locais
        const municipios = await municipioUfRepository.findAll();
        if (municipios.length > 0) {
          this.selecaoMunicipioLkp = municipios.map(municipio => ({
            name: municipio.regiao,
            value: municipio.value
          }));
        } else {
          this.$tools.alerta('Erro ao carregar municípios', "error");
        }
      }
    },

    async buscarLkpProjeto() {
      try {
        const response = await this.$http.get("/api/astec/getLkpProjeto");
        this.selecaoProjetoLkp = response.data.map(projeto => ({
          name: projeto.DISPLAY,
          value: projeto.ID,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpSafra() {
      try {
        const needsRefresh = await safraRepository.needsRefresh();

        if (needsRefresh) {
          const response = await this.$http.get("/api/astec/getLkpSafra");
          await safraRepository.bulkUpsert(response.data);
        }

        const safras = await safraRepository.findAll();

        // Mapeia para o formato que seu componente espera
        this.selecaoSafraLkp = safras.map(safra => ({
          name: safra.display,  // "2024/2025"
          value: safra.idApi,      // "1" (ou safra.value dependendo do que você usa)
          epoca: safra.tpepoca  // "V"
        }));

      } catch (err) {
        // Fallback...
        const safras = await safraRepository.findAll();
        if (safras.length > 0) {
          this.selecaoSafraLkp = safras.map(safra => ({
            name: safra.display,
            value: safra.id,
            epoca: safra.tpepoca
          }));
        }
      }
    },
    async buscarLkpInstituicaoFinanc(cdCooperado) {
      try {
        const response = await this.$http.get("/api/astec/getLkpInstituicaoFinanc/" + cdCooperado);
        this.instituicaoFinanceiraLkp = response.data.map(instituicaoFinanc => ({
          name: instituicaoFinanc.DISPLAY,
          value: instituicaoFinanc.ID,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpLinhaCredito() {
      try {
        const response = await this.$http.get("/api/astec/getLkpLinhaCredito");
        this.linhaCreditoLkp = response.data.map(linhaCredito => ({
          name: linhaCredito.DISPLAY,
          value: linhaCredito.ID,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpTipoProjeto() {
      try {
        const response = await this.$http.get("/api/astec/getLkpTipoProjeto");
        this.tipoProjetoLkp = response.data.map(tipoProjeto => ({
          name: tipoProjeto.DISPLAY,
          value: tipoProjeto.ID,
          perAstec: tipoProjeto.PER_ASTEC,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpItemAgropecuario() {
      try {
        const response = await this.$http.get("/api/astec/getLkpItemAgropecuario");
        this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
          name: itemAgropecuario.DISPLAY,
          value: itemAgropecuario.ID,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpModalidadeSeguro() {
      try {
        const response = await this.$http.get("/api/astec/getLkpModalidadeSeguro");
        this.selecaoModalidadeSeguroLkp = response.data.map(modalidadeSeguro => ({
          name: modalidadeSeguro.DISPLAY,
          value: modalidadeSeguro.ID,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpStatusProjeto() {
      try {
        const response = await this.$http.get("/api/astec/getLkpStatusProjeto");
        this.selecaoStatusProjetoLkp = response.data.map(statusProjeto => ({
          name: statusProjeto.DISPLAY,
          value: statusProjeto.ID,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpCooperado() {
      try {
        const response = await this.$http.get("/api/astec/getLkpCooperadoProjeto");
        this.cooperadoLkp = response.data.map(item => ({
          name: item.DISPLAY,
          value: item.ID,
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async FiltrarClientesRurais() {
      const dados = {
        cliente: this.selecaoClienteRural ? this.selecaoClienteRural.value : null,
        cpf_cnpj: this.cpfCnpj || null,
        mes_ano_aniversario: this.mesAno ? this.mesAno.value : '',
        e_mail: this.email ? this.email.trim() : '',
        sq_regiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cd_projeto: this.selecaoProjeto ? this.selecaoProjeto.value : null,
        safra: this.selecaoSafra ? this.selecaoSafra.name : null,
      };
      return dados;
    },

    async FiltrarProjetos(cdPessoa) {
      try {
        const response = await this.$http.get("/api/astec/getProjetosClienteRural/"+cdPessoa);
        console.log(response.data, "RESPONSE");
        this.projetosListados = response.data;

      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },


    async buscarItensProjetos(novoFiltro, page = 1, perPage = 10) {
      try {
        this.loadingGridProjetos = true;
        this.disabledFiltro = true;

        const response = await this.$http.post('/api/astec/getProjetos', {
          ...novoFiltro,
          page,
          per_page: perPage
        });

        this.$tools.fecharMenu();
        this.disabledFiltro = false;

        // Retorne só o array que o <Grid> espera
        return response.data
      } catch (error) {
        this.$tools.alerta(error.response.data.message, "warning");
        return {
          data: [],
          total: 0,
          current_page: 1
        };
      } finally {
        this.loadingGridProjetos = false;
        this.disabledFiltro = false;
      }
    },
    async getNomeRazaoUsuario() {
      try {
        const response = await this.$http.get("api/auth/me");
        this.cdPessoa = response.data.cd_pessoa;
      } catch (err) {
        console.log(err);
        this.logoutUser();
      }
    },

    async getClienteRuralFoto(sqClienteRural) {
      try {
        const response = await this.$http.get(`/api/astec/buscarFotoClietneRural/${sqClienteRural}`);
        return response.data?.nm_caminho_foto || null;
      } catch (error) {
        return null;
      }
    }

  },
};
